import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["charCount", "textarea", "termsCheckbox", "submitButton"];

  declare readonly hasCharCountTarget: boolean;
  declare readonly hasTextareaTarget: boolean;
  declare readonly charCountTarget: HTMLElement;
  declare readonly textareaTarget: HTMLTextAreaElement;
  declare readonly hasTermsCheckboxTarget: boolean;
  declare readonly hasSubmitButtonTarget: boolean;
  declare readonly termsCheckboxTarget: HTMLInputElement;
  declare readonly submitButtonTarget: HTMLButtonElement | HTMLInputElement;

  connect() {
    this.setupCharCounter();
    this.setupTermsSubmit();
  }

  private setupCharCounter() {
    if (!this.hasCharCountTarget || !this.hasTextareaTarget) return;

    const update = () => {
      this.charCountTarget.textContent = String(
        this.textareaTarget.value.length
      );
    };

    this.textareaTarget.addEventListener("input", update);
    this.textareaTarget.addEventListener("change", update);
    update();
  }

  private setupTermsSubmit() {
    if (!this.hasTermsCheckboxTarget || !this.hasSubmitButtonTarget) return;

    const update = () => {
      this.submitButtonTarget.disabled = !this.termsCheckboxTarget.checked;
    };

    this.termsCheckboxTarget.addEventListener("change", update);
    update();
  }
}
